const STORAGE_KEY = 'bagless_vapi_space_session';

function newSessionId() {
	if (typeof aptis !== 'undefined' && aptis.UUIDGenerator) {
		return new aptis.UUIDGenerator().generate();
	}
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID();
	}
	return `sess_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

function readStored() {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		if (!parsed || typeof parsed !== 'object') return null;
		const worldId = String(parsed.worldId ?? '').trim();
		const session = String(parsed.session ?? '').trim();
		if (!worldId || !session) return null;
		return { worldId, session };
	} catch (e) {
		return null;
	}
}

function writeStored(worldId, session) {
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ worldId, session }));
	} catch (e) {
		/* private mode / disabled storage */
	}
}

/**
 * One VAPI conversation session per user stay in a space (world).
 * Two agents in the same space share it. Changing space starts a new one.
 */
export function getVapiSpaceSessionString(worldId) {
	const world = String(worldId ?? '').trim();
	if (!world) return newSessionId();
	const stored = readStored();
	if (stored && stored.worldId === world) {
		return stored.session;
	}
	const session = newSessionId();
	writeStored(world, session);
	return session;
}
